// extracted by mini-css-extract-plugin
module.exports = {"ModalBerry":"ModalBerry_ModalBerry__1FVFr"};